var _path, _path2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAkarIconsMobileDevice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.911 20.8641H83.4556C71.9328 20.8641 62.5917 30.2051 62.5917 41.7279V208.639C62.5917 220.162 71.9328 229.503 83.4556 229.503H166.911C178.434 229.503 187.775 220.162 187.775 208.639V41.7279C187.775 30.2051 178.434 20.8641 166.911 20.8641Z",
    stroke: "white",
    strokeWidth: 8.63333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9667 17.2667H155.4V17.2667C155.4 26.8028 147.669 34.5333 138.133 34.5333H112.233C102.697 34.5333 94.9667 26.8028 94.9667 17.2667V17.2667Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 90.65,
    y1: 215.833,
    x2: 159.717,
    y2: 215.833,
    stroke: "white",
    strokeWidth: 8.63333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsMobileDevice);
export default __webpack_public_path__ + "static/media/akar-icons_mobile-device.9c94e2328ac17bb40e1d97885701a45b.svg";
export { ForwardRef as ReactComponent };